import {Component, Input, SimpleChanges} from "@angular/core";
import {UntypedFormControl, FormGroup, Validators} from "@angular/forms";
import {FormComponent} from "../form.component";
import {BankAccount} from "../../company/company.model";

type Form = {
  account_holder: string;
  acc_number: string;
}

@Component({
    selector: 'app-sepa-form',
    templateUrl: './sepa-form.component.html',
    styleUrls: [],
    standalone: false
})
export class SepaFormComponent extends FormComponent<BankAccount> {
  @Input() bankAccount: BankAccount
  @Input() autoFocus: boolean = true;

  protected createForm() {
    this.form = this.fb.group({
      account_holder: new UntypedFormControl(this.bankAccount?.account_holder ?? '', [Validators.required]),
      acc_number: new UntypedFormControl(this.bankAccount?.acc_number ?? '', [Validators.required]),
    })
  }

  formMapper(form: Form): BankAccount {
    const bank = this.bankAccount;
    bank.account_holder = form.account_holder;
    bank.acc_number = form.acc_number;
    return bank;
  }
}
